exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mm-empty{text-align:center;font-size:14px;line-height:22px;margin:0 8px}.mm-empty-image{margin:0 0 8px 0}.mm-empty-desc{margin:0}.mm-empty-footer{margin:16px 0 0 0}.mm-empty-no-data{padding:20px 10px;font-size:14px;color:#5d5d5d;text-align:center}.mm-empty-no-data:after,.mm-empty-no-data:before{content:\"\";display:table}.mm-empty-no-data:after{clear:both}", ""]);

// exports
